import { TrendingUp } from 'lucide-react'
import { strings } from '@/strings'
import type { TrendingTopic } from '@/services/trendingService'

interface TrendingTopicsProps {
    topics: TrendingTopic[]
    onTopicClick: (uri: string) => void
}

export function TrendingTopics({ topics, onTopicClick }: TrendingTopicsProps) {
    if (topics.length === 0) return null

    return (
        <section aria-label="Trending topics" className="pt-4">
            <h2 className="flex items-center gap-1.5 text-sm font-semibold text-text-secondary-light dark:text-text-secondary-dark uppercase tracking-wide pb-2">
                <TrendingUp size={16} aria-hidden="true" />
                {strings.trending.sectionTitle}
            </h2>
            <div className="flex flex-wrap gap-2">
                {topics.map(topic => (
                    <button
                        key={topic.uri}
                        type="button"
                        onClick={() => onTopicClick(topic.uri)}
                        className="inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium bg-primary/10 text-primary hover:bg-primary/20 transition-colors"
                    >
                        {topic.displayName}
                    </button>
                ))}
            </div>
        </section>
    )
}
